<div class="equipment-list-page">
  <form [formGroup]="equipmentForm">
    <mat-card class="no_box_shadow">
      <mat-card-content>
        <div class="example-button-row">
          <h4 class="page-title">Equipment</h4>
          <span class="__filter_icon" style="background-color: white;">
          </span>
          @if (addPermission) {
            <a class="__add_client" (click)="openForm()">
              <mat-icon class="__icon">add_circle</mat-icon>
              Create Equipment
            </a>
          }
        </div>
        <mat-divider></mat-divider>
        @if (viewPermission) {
          <table mat-table matSort [dataSource]="dataSource" (matSortChange)="sortData($event)" >
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef class="header">
                <div class="sorting_header">
                  <span mat-sort-header>Equipment Name</span>
                </div>
              </th>
              <td mat-cell *matCellDef="let element">{{element.name}}</td>
            </ng-container>
            <ng-container matColumnDef="code">
              <th mat-header-cell *matHeaderCellDef class="header">
                <div class="sorting_header">
                  <span mat-sort-header>Equipment Code</span>
                </div>
              </th>
              <td mat-cell *matCellDef="let element">{{element.code}}</td>
            </ng-container>
            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef class="header">
                <div class="sorting_header">
                  <span mat-sort-header>Equipment Type</span>
                </div>
              </th>
              <td mat-cell *matCellDef="let element">{{element.type}}</td>
            </ng-container>
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef class="header">
                <span>Action</span></th>
                <td mat-cell *matCellDef="let element">
                  @if (editPermission) {
                    <span class="__action_edit_icon" (click)="openForm(element)">
                      <mat-icon mat-cell>create</mat-icon>
                    </span>
                  }
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="groupColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: groupColumns;"></tr>
            </table>
          }

        </mat-card-content>
      </mat-card>
      @if (viewPermission) {
        <mat-paginator [pageSizeOptions]="pageSizeOptions" showFirstLastButtons [length]="totalEquipmentRecords"></mat-paginator>
      }
    </form>
  </div>
